export default __webpack_public_path__ + "static/media/p1.90d02e87.svg";